import { FiltersStore } from './FiltersStore';
import { SearchStore } from './SearchStore';

const stores = {
  FiltersStore: new FiltersStore(),
  SearchStore: new SearchStore(),
};

export default {
  stores: stores,
};
